module.exports = __webpack_public_path__ + "static/media/hp_04.b1a78106.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/home/JPEG/hp_04.jpg
// module id = 5815
// module chunks = 0